import { Fragment } from 'react';
import MediaControl from '@Components/Shared/MediaControl';

const Inspection = (props) => {

    const getSpecsByLanguage = (items, langId) => {
        var langID = langId.toString();
        var specList = items.filter(x => x.LangID === langID);
        if (specList && specList.length > 0) {
            return specList[0];
        } else if (langID !== '2') {
            return getSpecsByLanguage(items, 2);
        }
        return null;
    };

    const filterOutEmptySpecs = (langItem) => {
        if (langItem.Spec && langItem.Spec.length > 0) {
            var specs = langItem.Spec.filter(x => x.Name && x.Value);
            if (specs && specs.length > 0) {
                return specs;
            }
        }
        return null;
    };

    const renderConditionItem = (item, isPrintParagraph) => {
        let itemForCurrentLanguage = getSpecsByLanguage(item.Lang, props.LangID);

        // Hacky, but only way to get a MediaControl model injected here. 
        if (item.Pictures && item.Pictures.PhotoImageHandlerPath && item.Pictures.PhotoImageHandlerPath.length > 0) {
            item.MediaControl = JSON.parse(item.Pictures.PhotoImageHandlerPath[0]);
        }

        let hasMedia = (item.MediaControl && item.MediaControl.Media && item.MediaControl.Media.length > 0);
        if (itemForCurrentLanguage) {
            // Some specs come out empty either due to bad data or serialization errors, filter them out:
            let specs = filterOutEmptySpecs(itemForCurrentLanguage);

            if (props.isPrint) {
                if (isPrintParagraph) {
                    return (
                        <div>
                            <h4 id='inspectionsParagraphHeading' className='specifications-heading hide'>{itemForCurrentLanguage.Name}</h4>
                            <section id='inspectionsParagraph' className='print-specs-paragraph hide'>
                                {specs && specs.map(spec =>
                                    <div key={spec.Name}><span className='print-paragraph-spec-key'>{spec.Name}</span><span className='print-paragraph-spec-value'>{spec.Value}</span><span className='divider'>|</span>
                                    </div>)}
                            </section>
                        </div>
                    );
                } else {
                    return (
                        <div>
                            <h4 id='inspectionsTableHeading' className='specifications-heading'>{itemForCurrentLanguage.Name}</h4>
                            <section id='inspectionsTable' className='print-specs-table'>
                                {specs && specs.map(spec =>
                                    <div key={spec.Name} className='print-data-row column6'>
                                        <span className='print-data-label'>{spec.Name}</span>
                                        <span className='print-data-value'>{spec.Value}</span>
                                    </div>)}
                            </section>
                        </div>
                    );
                }
            } else {
                if (specs || hasMedia) {
                    return (
                        <div className='inspection'>
                            <h4 className='inspection__heading'>{itemForCurrentLanguage.Name}</h4>
                            <div className='inspection__specs-wrapper'>
                                <div className='inspection__specs'>
                                    {specs && specs.map(spec =>
                                        <Fragment key={spec.Name}>
                                            <div className='inspection__spec-label'><span dangerouslySetInnerHTML={{ __html: spec.Name }}></span></div>
                                            <div className='inspection__spec-value'>
                                                <span>{spec.Value}</span>
                                                {spec.Comments &&
                                                    <span className='inspection-specs__comment'>Comments: {spec.Comments}</span>}
                                            </div>
                                        </Fragment>)}
                                </div>
                                {hasMedia &&
                                    <div className='inspection__media'>
                                        {hasMedia && <MediaControl {...item.MediaControl} />}
                                    </div>}
                            </div>
                        </div>
                    );
                }
            }
        }
    };

    return (
        <>
            {(!props.isPrint && props.GeneralComments) &&
                <p>{props.GeneralComments}</p>}
            {props.ConditionItem.map(item => renderConditionItem(item, false))}
            {props.isPrint && props.ConditionItem.map(item => renderConditionItem(item, true))}
        </>
    );
};

export default Inspection;